(() => {
  const main = document.getElementById('MainContent');
  const element = document.getElementById('ink-market-context');
  if (!main || !element) return;
  let context;
  try { context = JSON.parse(element.textContent); } catch { return; }
  if (!['GB', 'CA'].includes(context.country)) return;
  if (context.locale && context.locale.split('-')[0] !== 'en') return;
  const init = () => {
    // Correct the existing badge in place; retain the US gallery and layout.
    const update = () => {
      if (!context.quantity) return;
      const label = Number(context.quantity).toLocaleString('en-GB') + ' PCS · UP TO ' + context.sizeLabel;
      main.querySelectorAll('.ip-gallery-badge--top').forEach(badge => {
        if (badge.textContent !== label) badge.textContent = label;
      });
    };
    update();
    const gallery = main.querySelector('[id^="product-media-"]');
    if (gallery) new MutationObserver(update).observe(gallery, { childList: true, subtree: true, characterData: true });
    main.dataset.inkUsReference = '20261014';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
